import api from './apiService';

export const getCompany = async () => {
    try {
        const response = await api.get('/company');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const updateCompany = async (data) => {
    try {
        const response = await api.put('company', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}